import type { EstimateLineRow } from './components/EstimateLineItemsEditor.js';
import type { EstimateLineItemDto } from './contractsMirror.js';

type EstimateLineItemFormSource = Pick<
  EstimateLineItemDto,
  'description' | 'quantity' | 'unit' | 'baseCost' | 'upchargePercent' | 'applyUpcharge'
>;

export function estimateLineItemForForm(line: EstimateLineItemFormSource): EstimateLineRow {
  return {
    description: line.description ?? '',
    quantity: String(line.quantity ?? ''),
    unit: line.unit ?? '',
    baseCost: String(line.baseCost ?? ''),
    upchargePercent: String(line.upchargePercent ?? ''),
    applyUpcharge: line.applyUpcharge,
  };
}
